module.exports = __webpack_public_path__ + "static/07-ca0364e0ff02dae72e4038d0c3a30052.jpg";